import React, { useEffect, useState } from "react";
import Dropdown from "../../../reusables/dropdown";
import { motion } from "framer-motion";
import {
  animationValues,
  transitionValues,
} from "../../../../utils/pageTransitions";
import InputField from "../../../reusables/input";
import { get_supplier_products } from "../../../../redux/actions/adminActions";
import { connect } from "react-redux";
import Spinner from "../../../reusables/spinner";
import Pagination from "../../../reusables/pagination";
import { product_status, periods } from "../../../../utils/options";

function Products({ accessToken, getProducts, supplier_products, selected }) {
  const [optionsActive, setOptions] = useState(null);
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState(supplier_products);
  const [selectedOrder, setSelect] = useState([]);
  const [orderDetails, setOrder] = useState(false);
  const token = accessToken;
  let params = {};

  useEffect(() => {
    getProducts({ token, selected, success });
  }, [selected]);

  useEffect(() => {
    setProducts(supplier_products);
  }, [supplier_products]);

  const success = () => {
    setLoading(false);
  };

  const handleSelect = (id) => {
    setSelect(id);
    setOrder(true);
  };

  const onPageChange = (page) => {
    setLoading(true);
    params = { ...params, ...{ page: page } };
    getProducts({ token, selected, success, params });
  };

  const [selectedTime, setTime] = useState("All dates");
  const handleSelectTime = (Item) => {
    setTime(Item);
    let filter = Item;
    setLoading(true);
    params = { ...params, ...{ filter: Item } };
    getProducts({ token, selected, success, params });
  };

  const [hasFilter, setFilter] = useState(false);
  const [selectedStatus, setStatus] = useState("Status");
  const handleFilter = (status) => {
    setStatus(status);
    params = { ...params, ...{ status: status } };
    getProducts({ token, selected, success, params });
  };

  const handleSearch = (e) => {
    setLoading(true);
    let value = e.target.value
    params = { ...params, ...{ search: value } };
    getProducts({ token, selected, success, params });
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="pt-3">
        <div className="spaceBetween">
          <div className="searchHolder">
            <InputField
              placeholder="Search by product name."
              icon
              iconClass="ri-search-line"
              onChange={handleSearch}
            />
          </div>

          <div className="alignOnly pt-2">
            <Dropdown value={selectedTime} className="mx-1">
              {periods?.map((item) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleSelectTime(item)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{item}</p>
                </div>
              ))}
            </Dropdown>
            <Dropdown value={selectedStatus} className="mx-1">
              <div
                className="isClickable hoverGreen"
                onClick={() => {
                  setStatus("All");
                  setFilter(false);
                }}
              >
                <p className="sectionText px-3 py-2 mb-0">All</p>
              </div>
              {product_status?.map((item) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleFilter(item)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{item}</p>
                </div>
              ))}
            </Dropdown>
          </div>
        </div>

        <div className="sectionHeight--mid pt-4">
          {!loading ? (
            products?.data?.length > 0 ? (
              <table className="table table__custom">
                <thead className="sectionText--small textIsGray table__head pb-2">
                  <tr className="">
                    <th className="">Product Id</th>
                    <th className="vAlign">Product Name</th>
                    <th className="vAlign">Category</th>
                    <th className="vAlign">Unit Cost</th>
                    <th className="vAlign">Unit Weight</th>
                    <th className="vAlign">Date Added</th>
                    {/* <th className="vAlign">Status</th> */}
                    {/* <th className="vAlign">Action</th> */}
                  </tr>
                </thead>
                <tbody className="">
                  {products?.data?.map((item) => (
                    <tr className="hasRadius">
                      <td className="alignOnly pt-3">
                        <input
                          type="checkbox"
                          className="isClickable"
                          name=""
                          id=""
                          value={item.id}
                          onChange={handleSelect}
                        />

                        <p className="mb-0  sectionText mx-2">
                          {item.product.product_id || "-"}
                        </p>
                      </td>

                      <td className="pt-3 vAlign">
                        <p className="mb-0  sectionText">
                          {item.product.product_name}
                        </p>
                      </td>

                      <td className="pt-3 vAlign">
                        <p className="mb-0  sectionText">
                          {item.product.category?.name}
                        </p>
                      </td>

                      <td className="vAlign pt-3">
                        <p className="mb-0 sectionText">
                          ₦ {item.product_price}
                        </p>
                      </td>

                      <td className="vAlign pt-3 address">
                        <p className="mb-0 sectionText">
                          {item.product.unit_weight || "-"}
                        </p>
                      </td>

                      <td className="vAlign pt-3">
                        <p className="mb-0  sectionText">{item.date}</p>
                      </td>

                      {/* <td className="center">
                        <div
                          className={`tag ${
                            item?.status === "active" ? "done" : "gray"
                          }`}
                        >
                          {item.status}
                        </div>
                      </td> */}

                      {/* <td className="vAlign pt-3">
                        <i
                          class="ri-more-line isClickable"
                          onClick={() => handleOptions(item.id)}
                        ></i>

                        {optionsActive === item?.id && (
                          <div className="options">
                            <div className="caret"></div>
                            <div className="p-2 textIsBold lAlign sectionText--small">
                              <div
                                className="py-2"
                                onClick={
                                  item.status === "active"
                                    ? () =>
                                        setDeActivate({
                                          ...deactivateModal,
                                          modal: true,
                                          id: [item.id],
                                        })
                                    : () =>
                                        setActivate({
                                          ...activateModal,
                                          modal: true,
                                          id: [item.id],
                                        })
                                }
                              >
                                {item.status === "active"
                                  ? "Deactivate"
                                  : "Activate"}
                              </div>
                              <div
                                className="py-2"
                                onClick={() => handleEdit(item)}
                              >
                                Edit
                              </div>
                              <div
                                className="isRed py-2"
                                onClick={() =>
                                  setDelete({
                                    ...deleteModal,
                                    modal: true,
                                    id: [item.id],
                                  })
                                }
                              >
                                Delete
                              </div>
                            </div>
                          </div>
                        )}
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="w-100 center sectionHeight--mid pt-4">
                <h2 className="sectionHead--small textIsBold textIsGreen">
                  No products found
                </h2>
              </div>
            )
          ) : (
            <Spinner big />
          )}
          <div className="d-flex justify-content-end">
            <Pagination
              onChange={onPageChange}
              page={products?.current_page}
              total={products?.total}
              per_page={products?.per_page}
            />
          </div>
        </div>
      </div>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  accessToken: state.admin.token,
  supplier_products: state.admin.supplier_products,
});

const mapDispatchToProps = (dispatch) => ({
  getProducts: (token, status, success) =>
    dispatch(get_supplier_products(token, status, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Products);
